var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media-orientation-check-c"},[_c('div',{staticClass:"animation-wrapper"},[_c('lottie-animation',{attrs:{"speed":0.75,"path":"assets/animations/mediaorientation.json","id":"reverse-animation"}}),_c('div',{staticClass:"media-orientation-message"},[_vm._v(" "+_vm._s(_vm.$t("common_lblMediaOrientationMsg"))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }